import { useEffect } from "react";
import {
  requestNotificationPermission,
  registerFirebaseMessagingSW,
  getFcmToken,
  saveFcmTokenToServer,
  listenForForegroundMessages,
} from "../services/fcmService";
import { toasterError, toasterWarning } from "../Components/toaster";

const useFirebaseMessaging = () => {
  useEffect(() => {
    let unsubscribeForeground = null;

    const initFirebaseMessaging = async () => {
      if (typeof window === "undefined") {
        return;
      }

      if (!("Notification" in window) || !("serviceWorker" in navigator)) {
        console.warn("Notifications or Service Workers are not available in this browser.");
        return;
      }

      const authToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");
      if (!authToken) {
        return;
      }

      try {
        const permission = Notification.permission === "granted"
          ? "granted"
          : await requestNotificationPermission();

        if (permission !== "granted") {
          toasterWarning("Notification permission was not granted.");
          return;
        }

       const serviceWorkerRegistration = await registerFirebaseMessagingSW();
        const fcmToken = await getFcmToken();

        if (fcmToken) {
          await saveFcmTokenToServer(fcmToken);
        }

        unsubscribeForeground = listenForForegroundMessages((payload) => {
          console.log("Foreground notification callback:", payload);
        });
      } catch (error) {
        const message = error?.message || "Failed to initialize Firebase push notifications.";
        // toasterError(message);
        console.error("Firebase messaging init error:", error);
      }
    };

    initFirebaseMessaging();
    const authHandler = () => {
      initFirebaseMessaging();
    };
    window.addEventListener('authUpdated', authHandler);

    return () => {
      window.removeEventListener('authUpdated', authHandler);
      if (typeof unsubscribeForeground === "function") {
        unsubscribeForeground();
      }
    };
  }, []);
};

export default useFirebaseMessaging;
